import React from 'react';

import { FaReddit, FaInstagram, FaYoutube } from 'react-icons/fa';

import {
  List,
  ListItem,
  ListItemLink
} from './Community.styles';

const Community = () => {
  return (
    <List color="secondary" isBlock>
      <ListItem>
        <ListItemLink to="https://www.reddit.com/r/ONEOKROCK/" target="_blank">
          <FaReddit /> <span>r/ONEOKROCK</span>
        </ListItemLink>
      </ListItem>
      <ListItem>
        <ListItemLink to="https://www.instagram.com/oneokrockworld/" target="_blank">
          <FaInstagram /> <span>ONE OK ROCK WORLD</span>
        </ListItemLink>
      </ListItem>
      <ListItem>
        <ListItemLink to="https://www.youtube.com/@kyopinnu" target="_blank">
          <FaYoutube /> <span>きょぴんぬ【KYOPINNU】</span>
        </ListItemLink>
      </ListItem>
    </List>
  );
};

export default Community;
